import { render, staticRenderFns } from "./AddPartnerCode.vue?vue&type=template&id=6bc36414"
import script from "./AddPartnerCode.vue?vue&type=script&lang=js"
export * from "./AddPartnerCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports